import CSVPreviewSection from '../CSVPreviewSection'
import {ReportGroupingLevel} from '../../../constants'

export default function ProfitLossCSVPreviewHeader(){}

ProfitLossCSVPreviewHeader.prototype = new CSVPreviewSection();

ProfitLossCSVPreviewHeader.prototype.init = function( firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel,showSpentTime,showAverageRates ){
    CSVPreviewSection.prototype.init.call( this );
    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.thirdGroupingLevel = thirdGroupingLevel;
    this.showSpentTime = showSpentTime;
    this.showAverageRates = showAverageRates;
    return this;
};

ProfitLossCSVPreviewHeader.prototype.addGroupingLevel = function(row, groupingLevel){
    ReportPreviewUtils.addCell( row, ReportPreviewUtils.getLevelPreviewName(groupingLevel ) );
};

ProfitLossCSVPreviewHeader.prototype.addRows = function( tBody )
{
    var mainHeaderRow = this.createRow();
    $(mainHeaderRow).addClass("headerGroupingRow");
    this.addGroupingLevel(mainHeaderRow,this.firstGroupingLevel);
    if( this.secondGroupingLevel != ReportGroupingLevel.NONE )
        this.addGroupingLevel(mainHeaderRow,this.secondGroupingLevel);
    if( this.thirdGroupingLevel != ReportGroupingLevel.NONE )
    {
        this.addGroupingLevel( mainHeaderRow, this.thirdGroupingLevel );
        this.addCell(mainHeaderRow, this.message("report.billing_type"));
    }

    var commonUnitText =" " +  this.message("report.common.unit_rate",[SystemSettings.currencySign])+ " ";
    var currencySign = " (" + SystemSettings.currencySign + ") ";
    var unitWork = this.message("report.common.unit_work");

    if(this.showSpentTime)
        this.addCell( mainHeaderRow, this.message( "report.profit_loss.spent.header" )+" " + unitWork );
    if(this.showAverageRates)
        this.addCell( mainHeaderRow, this.message( "report.profit_loss.billing_rate" ) + commonUnitText );
    this.addCell( mainHeaderRow, this.message("report.profit_loss.billable_amount.header") + currencySign );
    if(this.showAverageRates)
        this.addCell( mainHeaderRow, this.message( "report.profit_loss.average_user_rate" ) + commonUnitText );
    this.addCell( mainHeaderRow, this.message("report.profit_loss.cost.header") + currencySign);
    this.addCell( mainHeaderRow, this.message("report.profit_loss.pl.header") + currencySign );
    this.addRow( tBody, mainHeaderRow );
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/profitloss/ProfitLossCSVPreviewHeader.js